export const formatNo = phoneNo => {
  if (phoneNo.includes('+')) {
    return phoneNo;
  } else {
    return `+${phoneNo}`;
  }
};
